require('./bootstrap');

global.moment = require('moment-timezone');

global.Cropper = require('cropperjs').default;

import 'simplebar';
import 'simplebar/dist/simplebar.css';

global.uniqid = require('uniqid');

import Swal from "sweetalert2/dist/sweetalert2.js";
window.Swal = Swal;

import "sweetalert2/src/sweetalert2.scss";

import { create, registerPlugin } from 'filepond';
import FilePondPluginImagePreview from 'filepond-plugin-image-preview';
import FilePondPluginFileValidateType from 'filepond-plugin-file-validate-type';
import FilePondPluginFileEncode from 'filepond-plugin-file-encode';

import 'filepond/dist/filepond.min.css';
import 'filepond-plugin-image-preview/dist/filepond-plugin-image-preview.min.css';

import 'inputmask/lib/jquery.inputmask';
import 'inputmask/lib/extensions/inputmask.extensions';

registerPlugin(FilePondPluginImagePreview, FilePondPluginFileValidateType, FilePondPluginFileEncode);

require('gijgo');

require('select2');

global.JSZip = require('jszip');
//require( 'pdfmake' );

require('datatables.net-bs4');
require('datatables.net-buttons-bs4');
require('datatables.net-buttons/js/buttons.html5.js');
require('datatables.net-responsive-bs4');
require('datatable-sorting-datetime-moment');
//require('datatables.net-moment');
//require( 'datatables.net-select-bs4' );

require('slick-carousel');

require('spectrum-colorpicker');

require('./models');

import Mark from 'mark.js/dist/jquery.mark.es6';

window.doMarking = (text, element = 'content') => {
    const instance = new Mark(document.getElementById(element));
    const accuracy = decideAccuracy(text);
    instance.mark(text, {
        className: 'text-marked',
        accuracy: accuracy,
        exclude: [
            '.select2 *'
        ],
        each: function(element) {
            const el = $(element).closest('.form-group').find('input');
            if (!el.hasClass('field-marked')) {
                el.addClass('field-marked');
            }
            const tel = $(element).closest('.form-group').find('textarea');
            if (!tel.hasClass('field-marked')) {
                tel.addClass('field-marked');
            }
            const sel = $(element).closest('.form-group').find('.select2-container');
            if (!sel.hasClass('field-marked')) {
                sel.addClass('field-marked');
            }
        }
    });
}

window.markRegex = (regex, element = 'content') => {
    console.log(regex);
    const instance = new Mark(document.getElementById(element));

    instance.markRegExp(regex, {
        className: 'text-marked',
        exclude: [
            '.select2 *'
        ],
        each: function (element) {
            const el = $(element).closest('.form-group').find('input');
            if (!el.hasClass('field-marked')) {
                el.addClass('field-marked');
            }
            const tel = $(element).closest('.form-group').find('textarea');
            if (!tel.hasClass('field-marked')) {
                tel.addClass('field-marked');
            }
            const sel = $(element).closest('.form-group').find('.select2-container');
            if (!sel.hasClass('field-marked')) {
                sel.addClass('field-marked');
            }
        }
    });
};

function decideAccuracy(text) {
    // if there is word which only has 3 chars or less make it search for
    // exactly words
    if (text.split(' ').filter(x => x .length <= 3).length > 0) {
        return 'exactly';
    }

    return 'partially';
}

window.readOnlyPlacement = (parentEl, clear) => {
    const forms = parentEl ? $(parentEl) : $(".is-archived");
    const inputs = ".form-control:not([type='search'],[data-type='datepicker']), .switch-contain input, .form-control-wrap:not(.archive-skip) input:not([type='search']), .datatable-command, button:not(.btn-toggle,.paginate_button,[data-toggle='collapse']), .live-form select, select.form-control, textarea";

    if (parentEl) {
        forms.find(inputs).not('.archive-skip').prop('disabled', false).removeClass('disabled form-input-readonly');
        forms.find(".form-datepicker, .form-check, .form-control-counter").not('.archive-skip').removeClass('form-input-readonly');
    } else {
        forms.find(inputs).not('.archive-skip').prop('disabled', 'disabled').addClass('disabled form-input-readonly');
        forms.find(".form-datepicker, .form-check, .form-control-counter").not('.archive-skip').addClass('form-input-readonly');
    }

    if (!clear) {
        const timeout = setTimeout(() => {
            readOnlyPlacement(0, 1);
            clearTimeout(timeout);
        }, 500);
    }
}

$(function () {
    readOnlyPlacement();

    // Idle  Time
    function idleLogout() {
        const KEY_NAME = 'tps_last_activity';
        const LAST_ACTIVITY_TIMEOUT = 60 * 60 * 1000; // 1 hour
        const SESSION_LIFETIME = 70 * 60 * 1000; // 70 minutes
        let t, modalOpened, autoLogoutTimer, logoutTimeLeft = 15;
        let throttleLastRan, throttleLastFunc, throttleLimit = 1000;

        if (window.location.pathname.includes('/login')) {
            localStorage.removeItem(KEY_NAME);
        } else {
            localStorage.setItem(KEY_NAME, new Date());
        }

        function throttle(fn) {
            return function () {
                const context = this, args = arguments;

                if (!throttleLastRan) {
                    fn.apply(context, args);
                    throttleLastRan = Date.now();
                } else {
                    clearTimeout(throttleLastFunc);
                    throttleLastFunc = setTimeout(function() {
                        if (Date.now() - throttleLastRan >= throttleLimit) {
                            fn.apply(context, args);
                            throttleLastRan = Date.now();
                        }
                    }, throttleLimit - (Date.now() - throttleLastRan));
                }
            };
        };

        const throttleResetTimer = throttle(resetTimer);

        window.onload = throttleResetTimer;
        window.onmousemove = throttleResetTimer;
        window.onmousedown = throttleResetTimer;  // catches touchscreen presses as well
        window.ontouchstart = throttleResetTimer; // catches touchscreen swipes as well
        window.ontouchmove = throttleResetTimer;  // required by some devices
        window.onclick = throttleResetTimer;      // catches touchpad clicks as well
        window.onkeydown = throttleResetTimer;
        window.addEventListener('storage', throttleResetTimer, true);
        window.addEventListener('scroll', throttleResetTimer, true); // improved; see comments

        function showModalLogout() {
            modalOpened = true;
            popup_open('popup-logout');
            startCountDown();
            clearTimeout(t);
        }

        function resetTimer() {
            if (window.location.pathname.includes('/login')) return;

            if (modalOpened) {
                clearAutoLogout();
            };

            const tokenExpired = ((new Date) - Date.parse(localStorage.getItem(KEY_NAME))) >= SESSION_LIFETIME;

            if (tokenExpired) {
                clearInterval(autoLogoutTimer);
                document.getElementById('logout-form').submit();
                clearAutoLogout();
                return;
            }

            localStorage.setItem(KEY_NAME, new Date());

            clearTimeout(t);
            // time is in milliseconds
            t = setTimeout(showModalLogout, LAST_ACTIVITY_TIMEOUT);
        }

        function startCountDown() {
            autoLogoutTimer = setInterval(function () {
                if (logoutTimeLeft <= 0) {
                    clearInterval(autoLogoutTimer);
                    document.getElementById('logout-form').submit();
                    clearAutoLogout();
                    return;
                }
                $('#autoLogoutTimeLeft').text(logoutTimeLeft);
                logoutTimeLeft -= 1;
            }, 1000);
        }

        function clearAutoLogout() {
            clearTimeout(t);
            clearInterval(autoLogoutTimer);
            popup_close('popup-logout');
            modalOpened = false;
            logoutTimeLeft = 15;
            $('#autoLogoutTimeLeft').text(logoutTimeLeft);
        }

        $('#cancelAutoLogout').on('click', function () {
            clearAutoLogout();
        });
    }
    idleLogout();

    if (window.app_data.search_query) {
        setTimeout(function () {
            window.doMarking(window.app_data.search_query);
        }, 1000);
    }

    // Password toggle visibility
    $("#passwordField .toggle-visibility").on('click', function (event) {
        event.preventDefault();
        if ($('#passwordField input').attr("type") == "text") {
            $('#passwordField input').attr('type', 'password');
            $('#passwordField i').addClass("fa-eye-slash");
            $('#passwordField i').removeClass("fa-eye");
        } else if ($('#passwordField input').attr("type") == "password") {
            $('#passwordField input').attr('type', 'text');
            $('#passwordField i').removeClass("fa-eye-slash");
            $('#passwordField i').addClass("fa-eye");
        }
    });
});

window.identify = (input) => {
    // unique empty object
    const unset = new Object();
    // we need wrapper to ensure we have access to the same unique empty object
    const closure = (input) => {
        // wrap each input into this
        const handler = new Function();
        handler.input = input;
        // return wrappers proxy
        return new Proxy(handler, {
            // keep traversing
            get: (target, name) => {
                // if undefined supplied as initial input
                if (!target.input) {
                    return closure(unset);
                }
                // otherwise
                if (target.input[name] !== undefined) {
                    // input has that property
                    return closure(target.input[name]);
                } else {
                    return closure(unset);
                }
            },
            // result with fallback
            apply: (target, context, args) => {
                return handler.input === unset ?
                    args[0] : handler.input;
            }
        })
    }
    return closure(input);
}

Number.prototype.format = function(n, x) {
    var re = '\\d(?=(\\d{' + (x || 3) + '})+' + (n > 0 ? '\\.' : '$') + ')';
    return this.toFixed(Math.max(0, ~~n)).replace(new RegExp(re, 'g'), '$&,');
};

Object.byString = function(o, s) {
    s = s.replace(/\[(\w+)\]/g, '.$1'); // convert indexes to properties
    s = s.replace(/^\./, '');           // strip a leading dot
    var a = s.split('.');
    for (var i = 0, n = a.length; i < n; ++i) {
        var k = a[i];
        if (k in o) {
            o = o[k];
        } else {
            return;
        }
    }
    return o;
}

window.app_data = typeof app_data=='undefined'?{}:app_data;
app_data.user = typeof user=='undefined'?{}:user;
app_data.alerts = typeof alerts=='undefined'?[]:alerts;
app_data.options = typeof app_options=='undefined'?{}:app_options;
app_data.models = app_models;
app_data.favorites = typeof favorites=='undefined'?[]:favorites;
app_data.global_alert_message = '';
app_data.placement = typeof app_data.placement == 'undefined' ? {} : app_data.placement;
app_data.search = typeof app_data.search == 'undefined' ? "" : app_data.search;

window.Vue = require('vue');

require('./vue');
import VTooltip from 'v-tooltip';

import VueResource from 'vue-resource';
import _ from 'lodash';
Vue.use(VueResource);
Vue.component('InfiniteLoading', require('vue-infinite-loading'));

window.merge_model = (input, model)=>{
    $.each(input, function(k, v){

        if(k in model){

            if(Array.isArray(input[k])){
                $.each(input[k], function(i, v){
                    merge_model(input[k][i], model[k][0]);
                });
            }else if(isAnObject(model[k])){
                input[k] = _.mergeWith(
                    {}, input[k], model[k],
                    (a, b) => {
                        return a === null ? b : a;
                    }
                );

                merge_model(input[k], model[k]);
            }
        }
    });
    return input;
}

function isAnObject(obj)
{
    if(obj==null) return false;
    return obj.constructor.name.toLowerCase() === "object"
}

window.ll_defined = (val)=> {
    return (typeof val !== 'undefined'&&val!==null);
};

merge_model(app_data, app_models);

let methods = {
    nav_close() {
        nav_close();
    },
    clone_create(url, post_data, arr, model, callback, failedcb) {
        let $this = this;

        arr.push(model);
        let index = arr.length - 1;

        $.ajax({
            url:url,
            method:"POST",
            data: post_data,
            dataType:"json",
            success: (response) => {
                if (typeof response['error'] !== 'undefined') {
                    message(response['error'], 1);

                    $this.$delete(arr, index);
                    if (typeof failedcb === 'undefined') return;
                    failedcb(response);

                    return;
                }

                merge_model(response, model);
                arr.splice(index, 1, response);

                if (typeof callback === 'undefined') return;
                callback(response);
            },
            error: (response)=>{
                message("Failed to create removing from display", 1);

                $this.$delete(arr, index);
                if (typeof failedcb === 'undefined') return;
                failedcb(response);
            }
        });
    },
    clone_remove(url, item, arr, index, callback, failedcb){
        let $this = this;

        if(typeof item.id == 'undefined' || item.id == "" || item.id == null){

            message("Failed to remove record", 1);

            if(typeof failedcb === 'undefined') return;

            failedcb();

            return;

        }

        $this.$delete(arr, index);

        $.ajax({
            url:url,
            method:"POST",
            data:{"id":item.id},
            dataType:"json",
            success: (response)=>{

                if(typeof response['error'] !== 'undefined'){
                    message(response['error'], 1);
                    arr.splice(index, 1, item);

                    if(typeof failedcb === 'undefined') return;
                    failedcb();
                    return;
                }

                message("Record Removed");

                if(typeof callback === 'undefined') return;

                callback(response);

            },
            error: (response)=>{

                message("Failed to remove adding to display", 1);

                arr.splice(index, 1, item);

                if(typeof failedcb === 'undefined') return;
                failedcb(response);

            }
        });
    },
    clone_remove_value(url, item, arr, index) {
        let $this = this;
        $this.$delete(arr, index);
        $.ajax({
            url: url,
            method: "POST",
            data: { "value": item },
            dataType: "json",
            success: (response) => {
                if (typeof response['error'] !== 'undefined') {
                    message(response['error'], 1);
                    arr.splice(index, 1, item);
                    return;
                }

                message("Record Removed");
            },
            error: (response) => {
                message("Failed to remove adding to display", 1);
                arr.splice(index, 1, item);
            }
        });
    },
    moment(val){
        return window.moment(val);
    },
    favorite(url){
        if(typeof url == 'undefined') url = window.location.pathname;
        return this.favorites.filter(function(favorite){
            let match = favorite.name.replace(/\/$/, "");
            url = url.replace(/\/$/, "");
            return match == url;
        }).length;
    },
    toggle_favorite(){
        let url = window.location.pathname;
        let favorites = this.favorites.filter(function(favorite){
            let match = favorite.name.replace(/\/$/, "");
            url = url.replace(/\/$/, "");
            return match != url;
        });
        if(favorites.length==this.favorites.length){
            this.favorites.push({
                name: url
            });
        }else{
            this.favorites = favorites;
        }
    },
    has_any_role(roles){
        let has_role = false;
        for(let role of roles){
            for(let user_role of user.roles){
                if(role.toLowerCase()==user_role.name.toLowerCase()) has_role = true;
            }
        }
        return has_role;
    }
};

if (typeof app_methods !== 'undefined') {
    methods = {...methods, ...app_methods};
}

let watch = {};

if (typeof app_live !== 'undefined') {
    let channels = [];
    $.each(app_live, function(k, v){
        let timeout;
        let skip_watch = false;
        if(!channels.includes(v.channel)){
            channels.push(v.channel);
            // Echo.private(v.channel)
            // .listenForWhisper('update', (e) => {
            //     skip_watch = true;
            //     if(typeof e.user !== 'undefined'){
            //         let msg = e.user.first_name + " " + e.user.last_name + " is editing page!";
            //         message(msg);
            //     }
            //     if(e.key in app){
            //         Vue.set(app, e.key, e.update);
            //     }
            // });
        }

        watch[k] = {
            handler(val, oldVal) {
                if(skip_watch){
                    setTimeout(() => {
                        skip_watch = false;
                    }, 10);
                    return;
                }
                // Echo.private(v.channel)
                // .whisper('update', {
                //     "key":k,
                //     "update":val,
                //     "user":this.user
                // });
            },
            deep: true
        }
    });
}

let required_pages = [
    "/placement/edit", "/placement/properties/edit", "/placement/budget/edit"
];

let required_fields = {
    "/placement/edit": {
        "placement.insurance_company":{
            "message":"Insurance Company"
        },
        "placement.claim_number":{
            "message":"Claim Number"
        },
        "placement.policy_id":{
            "message":"Type of Policy"
        },
        "placement.loss_date":{
            "message":"Loss Date"
        },
        "placement.loss_type":{
            "message":"Type of Loss"
        },
        "placement.policyholder.name":{
            "message":"Policyholder"
        },
        "placement.loss_address.address.address":{
            "message":"Loss Address"
        },
        "placement.loss_address.address.city":{
            "message":"Loss Address City"
        },
        "placement.loss_address.address.state":{
            "message":"Loss Address State"
        },
        "placement.loss_address.address.zip":{
            "message":"Loss Address Zip"
        },
        "placement.loss_address.bedrooms":{
            "message":"Loss Address Bedrooms"
        },
        "placement.loss_address.bathrooms":{
            "message":"Loss Address Bathrooms"
        },
        "placement.loss_address.sqft":{
            "message":"Loss Address Sqft"
        }
    },
    "/placement/properties/edit": {
        "property.property_contacts[0].name":{
            "message": "Landlord Name"
        },
        "property.property_contacts[0].contact.phone":{
            "message": "Landlord Phone"
        },
        "property.sqft": {
            "message": "Square Feet"
        },
        "property.baths": {
            "message": "Bathrooms"
        },
        "property.beds": {
            "message": "Bedrooms"
        },
        "property.address.address": {
            "message": "Address"
        },
        "property.address.city": {
            "message": "City"
        },
        "property.address.state": {
            "message": "State"
        },
        "property.address.zip": {
            "message": "Zip"
        }
    },
    "/placement/budget/edit": {
        "budget.unfurnished_rent":{
            "message": "Rent"
        },
        "budget.furnished":{
            "message": "Is Furnished?"
        },
        "budget.payable_to":{
            "message": "Rent Payable To"
        },
        "budget.pro_rated_start_date":{
            "message": "Pro Rated Start Date"
        },
        "budget.pro_rated_end_date":{
            "message": "Pro Rated End Date"
        },
        "budget.landlord_deposit":{
            "message": "Landlord Deposit"
        },
        "budget.landlord_paidby_id":{
            "message": "Landlord Deposit Paid By"
        }
    }
};

if (identify(app_data).placement.hotel_placements(false)) {

    let hp = app_data.placement.hotel_placements.length;

    function hp_verification(){
        let hotel_verification = {};
        hp = app_data.placement.hotel_placements.length;
        let ref = 1;
        while(hp--){
            hotel_verification["placement.hotel_placements["+hp+"].hotel.email"] = {
                "message": "Hotel " +ref+ " E-mail"
            };

            hotel_verification["placement.hotel_placements["+hp+"].hotel.quickbooks"] = {
                "message": "Hotel " +ref+ " Quickbooks"
            };
            ref++;
        }
        required_pages.push("/placement/hotels");
        required_fields["/placement/hotels"] = hotel_verification;
    }

    watch["placement.hotel_placement"] = {
        handler(nv){
            hp_verification();
        },
        deep: true
    }
    hp_verification();
}

let path = window.location.pathname;

let sub = path.substr(path.lastIndexOf("/")+1, path.length);

while(!isNaN(sub)||sub==""){
    path = path.substr(0, path.lastIndexOf("/"));
    sub = path.substr(path.lastIndexOf("/")+1, path.length);
}

let computed = {
    path(){
        return window.location.pathname;
    },
    fields(){
        let fields = [];

        for(let field_key of Object.keys(required_fields[path])){
            let field = required_fields[path][field_key];
            let value = _.get(this, field_key, "");
            let conditional_skip = false;
            if(typeof field.conditions !== 'undefined'){
                for(let condition_key of Object.keys(field.conditions)){
                    if(_.get(app, condition_key, "")!=field.conditions[condition_key]){
                        conditional_skip = true;
                    }
                }
            }

            if(conditional_skip) continue;

            if(value===""||value==null) fields.push(field["message"]);
        }

        return fields.join(", ");
    }
};

if (typeof app_computed !== 'undefined'){
    computed = {...computed, ...app_computed};
}

if(typeof app_watch !== 'undefined'){
    watch = {...watch, ...app_watch};
}
Vue.use(VTooltip, {
    defaultHtml: false,
});
window.app = new Vue({
    el: '#app',
    data: app_data,
    methods: methods,
    watch: watch,
    computed: computed,
    mounted() {
        // if (window.user && !window.user.password_changed) {
        //     alert("Please change your initial password.");
        // }

        setTimeout(function() {
            $(".loading-overlay").hide();
        }, 0);

        if ($('#recaptcha-element').length) {
            window.tpsRecaptchaApiLoaded = function () {
                grecaptcha.render('recaptcha-element', { "sitekey": process.env.MIX_RECAPTCHA_SITE_KEY, "theme": "light", "size": "normal", "tabindex": 0, "callback": null, "expired-callback": null, "error-callback": null });
            }

            const recaptchaScript = document.createElement("script");
            recaptchaScript.setAttribute(
                "src",
                "https://www.google.com/recaptcha/api.js?onload=tpsRecaptchaApiLoaded&render=explicit"
            );
            document.head.appendChild(recaptchaScript);
        }
    }
});

require('./alert');

require('./bizdev');

require('./popup');

require('./profile');

require('./clone');

require('./dataTables');

require('./validate');

require('./pages');

(function ($) {
    $.ajaxSetup({
        headers: {
            'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
        }
    });

    $(function (){
        // Search placement toggle switch
        $('.toggle-group-wrapper').on('click', function () {
            if ($('#searchPlacement input[name="is_active"]').is(':checked')) {
                $('#searchPlacement input[name="is_active"]').prop('checked', false);
            } else {
                $('#searchPlacement input[name="is_active"]').prop('checked', true);
            }
        });

        $(window).on('resize', function () {
            checkMenu()
        });

        function notification_worker(no_repeat = false) {
            if (window.location.pathname.includes('login') || window.location.pathname.includes('password/reset') || window.location.pathname.includes('two-factor-challenge')) {
                return;
            }

            $.ajax({
                url: '/api/notification_counts',
                success: function (data) {
                    let total_alerts = data.alerts > 99 ? '99+' : data.alerts;
                    let update_request_counts = data.update_request_counts > 99 ? '99+' : data.update_request_counts;
                    let total_payables = data.payables > 99 ? '99+' : data.payables;
                    let total_invoices = data.invoices > 99 ? '99+' : data.invoices;
                    let completed_invoices = data.completed_invoices > 99 ? '99+' : data.completed_invoices;
                    let qualifying_properties = data.qualifying_properties > 99 ? '99+' : data.qualifying_properties;

                    if (data.alerts > 0) {
                        $("#alert-counts").show().text(total_alerts);
                    } else {
                        $("#alert-counts").hide();
                    }

                    if (data.qualifying_properties > 0) {
                        $("#qualifying-properties-counts").show().text(qualifying_properties);
                    } else {
                        $("#qualifying-properties-counts").hide();
                    }

                    if (data.submitted_claims > 0) {
                        $(".submitted-claim-menu").addClass('bg-danger text-white');
                    } else {
                        $(".submitted-claim-menu").removeClass('bg-danger text-white');
                    }

                    if ($("#update-request-counts").length) {
                        if (data.update_request_counts > 0) {
                            $("#update-request-counts")
                                .show()
                                .text(update_request_counts);
                        } else {
                            $("#update-request-counts").hide();
                        }
                    }

                    if (data.payables > 0) {
                        $('#payable-counts').show().text(total_payables);
                    } else {
                        $('#payable-counts').hide()
                    }

                    if (data.invoices > 0) {
                        $('#invoice-counts').show().text(total_invoices);
                    } else {
                        $('#invoice-counts').hide()
                    }

                    if (data.completed_invoices > 0) {
                        $('#completed-invoice-counts').show().text(completed_invoices);
                    } else {
                        $('#completed-invoice-counts').hide()
                    }
                    
                },
                statusCode: {
                    401: function () {
                        window.alert('Session ended. Please, try to login!')
                        window.location.reload();
                    }
                },
                complete: function () {
                    if (!no_repeat) {
                        setTimeout(notification_worker, 15000);
                    }
                }
            });
        };
        window.notification_worker = (no_repeat = true) => notification_worker(no_repeat);
        notification_worker();

        let wake_me_up_timer = null;
        function wake_me_up() {
            if (!(window.location.pathname.includes('login') || window.location.pathname.includes('password/reset'))) {
                if (wake_me_up_timer !== null) {
                    clearTimeout(wake_me_up_timer);
                }
                return;
            }

            $.ajax({
                url: '/api/a-caffeine',
                success: function () {},
                statusCode: {},
                complete: function () {
                    wake_me_up_timer = setTimeout(wake_me_up, 15000);
                }
            });
        }
        window.wake_me_up = () => wake_me_up();
        wake_me_up();

        $('.btn-hamburger').on('click', function () {
            if (!$('#searchPlacement').hasClass('active')) {
                $('#searchPlacement').addClass('active');
            } else {
                $('#searchPlacement').removeClass('active');
            }

            if (!$('.navbar-tps-main').hasClass('active')) {
                $('.navbar-tps-main').addClass('active');
            } else {
                $('.navbar-tps-main').removeClass('active');
            }

            if (!$(this).hasClass('is-active')) {
                $(this).addClass('is-active');
            } else {
                $(this).removeClass('is-active');
            }
        });
        $('#addAlert').on('click', function () {
            popup_open('editor-new_alert');
        });

        $(window).on("popup_open", function(e, type, opts) {
            if (type !== "editor-new_alert") return;

            const pop = $(`.popup[data-type=${type}]`);

            app_data.global_alert_message = '';
            pop.find('select[name="user_id"]')
                .val(null)
                .trigger("change")
                .trigger("change");
            pop.find('select[name="alert_template_id"]')
                .val(null)
                .trigger("change")
                .trigger("change");
            pop.find('select[name="parent_type"]')
                .val(null)
                .trigger("change")
                .trigger("change");
            pop.find('.alert-type-parents').removeClass('d-none');

            if (!opts) return;
            if (!opts.el) return;

            const el = $(opts.el);
            const data = {
                parent_type: el.attr('data-parent_type'),
                parent_id: el.attr('data-parent_id'),
                name: el.attr('data-name'),
            }
            let model = data.parent_type.replace('App\\', '').toLowerCase();
            let optionName = model;
            if (!['contact', 'company', 'vendor', 'hotel', 'event'].includes(model)) {
                model = 'placement';
                optionName = 'Policyholder';
            }

            pop.find('select[name="parent_type"]')
                .empty()
                .append(`<option value="${data.parent_type}">${optionName}</option>`)
                .val(data.parent_type)
                .trigger('change');

            pop.find(`select[name="parent_id"]`).val('');
            pop.find(`.alert-${model} select[name="parent_id"]`)
                .empty()
                .append(`<option value="${data.parent_id}">${data.name}</option>`)
                .val(data.parent_id.toString())
                .trigger('change');
            pop.find('.alert-type-parents').addClass('d-none');
        });

        $(window).on('/api/alert/create.success', function (e, data) {
            popup_close("editor-new_alert");
            popup_close("editor-crm_alerts");

            if (!data.alert || !app_data.user_alerts) return;

            const alert = data.alert;

            if (placement && placement.id != alert.placement_id) return;

            const existing = app_data.user_alerts.findIndex((user) => user.id == alert.user_id);

            if (existing !== -1) {
                app_data.user_alerts[existing].alerts_count = app_data.user_alerts[existing].alerts_count + 1;
            } else {
                alert.user.alerts_count = 1;
                app_data.user_alerts.push(alert.user);
            }
        });

        const handleAlertParentType = function () {
            const type = $(this).val() ? $(this).val().replace('App\\', '').toLowerCase() : '';
            $('.alert-type-options').addClass('d-none');
            $(`.alert-${type}`).removeClass('d-none');

            const pop = $('.popup[data-type="editor-new_alert"]');
            pop.find('[name="parent_id"]').val('').trigger("change").trigger("change");
            pop.find('[name="custom_item"]').val('');
        }

        $('[data-type="editor-new_alert"] [name="parent_type"]').on('change', handleAlertParentType);

        // Add placement modal
        $('#addPlacement').on('click', function () {
            popup_open('editor-new_placement');
        });

        $('[data-type="editor-new_placement"] input[name="claim_tbd"]').on('change', function () {
            if (this.checked) {
                $('[data-type="editor-new_placement"] input[name="claim_number"]').val('TBD').prop('readonly', true);
            } else {
                $('[data-type="editor-new_placement"] input[name="claim_number"]').val('').prop('readonly', false);
            }
        });

        $('[data-type="editor-new_placement"] input[name="company_tbd"]').on('change', function () {
            if (this.checked) {
                $('[data-type="editor-new_placement"] select[name="company_id"]').select2({disabled:'readonly'});
                $('[data-type="editor-new_placement"] input[name="new_company"]').prop('disabled', true);
                $('[data-type="editor-new_placement"] input[name="new_company"]').parent().addClass('form-input-readonly');
            } else {
                $('[data-type="editor-new_placement"] select[name="company_id"]').select2({disabled:false});
                $('[data-type="editor-new_placement"] input[name="new_company"]').prop('disabled', false);
                $('[data-type="editor-new_placement"] input[name="new_company"]').parent().removeClass('form-input-readonly');
            }
        });

        $('[data-type="editor-new_placement"] input[name="new_company"]').on('change', function () {
            if (this.checked) {
                $('[data-type="editor-new_placement"] #new_company').show();
                $('[data-type="editor-new_placement"] input[name="company_tbd"]').prop('disabled', true);
                $('[data-type="editor-new_placement"] input[name="company_tbd"]').parent().addClass('form-input-readonly');
                $('[data-type="editor-new_placement"] select[name="company_id"]').prop('disabled', true);
                $('[data-type="editor-new_placement"] #new_company input, [data-type="editor-new_placement"] #new_company select').prop('disabled', false);
            } else {
                $('[data-type="editor-new_placement"] #new_company').hide();
                $('[data-type="editor-new_placement"] input[name="company_tbd"]').prop('disabled', false);
                $('[data-type="editor-new_placement"] input[name="company_tbd"]').parent().removeClass('form-input-readonly');
                $('[data-type="editor-new_placement"] select[name="company_id"]').prop('disabled', false)
                $('[data-type="editor-new_placement"] #new_company input, [data-type="editor-new_placement"] #new_company select').prop('disabled', true);
            }
        });

        $(window).on('/api/placement/create.success', function (e, response) {
            setTimeout(function () {
                const url = '/placement/edit/' + response.id;
                const element = document.createElement('a');
                element.setAttribute('href', url);
                element.style.cssText = 'display:none;';
                document.body.appendChild(element);
                element.click();
                document.body.removeChild(element);
            }, 500);
        });
        // End placement modal

        // $(window).on('/api/profile/update.success', function (e, response) {
        //     setTimeout(function () {
        //         if (response.redirect) {
        //             const element = document.createElement('a');
        //             element.setAttribute('href', response.redirect);
        //             element.style.cssText = 'display:none;';
        //             document.body.appendChild(element);
        //             element.click();
        //             document.body.removeChild(element);
        //         }
        //     }, 500);
        // });

        $('.ip-address-field').inputmask({
            alias: 'ip',
            greedy: false
        });

        // Form Search
        // $('#searchFilter').on('click', function () {
        //     popup_open('search-filter');
        // });

        // $('#closeSearchFilter').on('click', function () {
        //     popup_close('search-filter');
        //     $('#searchPlacement input[type="text"]').trigger('focus');
        // });

        // window.addEventListener('click', function(e) {
        //     if ($('.popup[data-type="search-filter"]').hasClass('active')) {
        //         if (!document.querySelector('.popup-content').contains(e.target) && !document.querySelector('#closeSearchFilter').contains(e.target) && !document.querySelector('#searchFilter').contains(e.target)) {
        //             popup_close('search-filter');
        //             $('#searchPlacement input[type="text"]').trigger('focus');
        //         }
        //     }
        // })

        // Upload File
        const inputElement = document.querySelectorAll('input[filepond]');

        inputElement.forEach(element => {
            let availableImageUrl = element.getAttribute('data-url');
            let inputName = element.getAttribute('name');

            const pond = create(element, {
                allowMultiple: false,
                labelIdle: 'Drag &amp; drop your picture here or <span class="filepond--label-action"> browse </span>',
                acceptedFileTypes: 'image/jpeg, image/png, image/svg+xml',
                allowFileEncode: true,
                files: availableImageUrl ? [availableImageUrl] : [],
            });

            pond.on('addfile', (err, file) => {
                let baseURL = file.getFileEncodeDataURL()
                $('input[name="' + inputName + '_blob"]').val(baseURL).trigger('update');
                $('#siteLogo').attr('src', baseURL);
            });

            pond.on('removefile', (err, file) => {
                $('input[name="' + inputName + '_blob"]').val('').trigger('update');
                $('#siteLogo').attr('src', '/images/logo.svg');
            });
        });

        function lightenDarkenColor(col, amt) {
            let usePound = false;
            if (col[0] == "#") {
                col = col.slice(1);
                usePound = true;
            }
            let num = parseInt(col, 16);
            let r = (num >> 16) + amt;
            if (r > 255) r = 255; else if (r < 0) r = 0;
            let b = ((num >> 8) & 0x00FF) + amt;
            if (b > 255) b = 255; else if (b < 0) b = 0;
            let g = (num & 0x0000FF) + amt;
            if (g > 255) g = 255; else if (g < 0) g = 0;
            return (usePound ? "#" : "") + (g | (b << 8) | (r << 16)).toString(16);
        }

        if (window.user_preferences) {
            let colors = {};
            colors.primary_bg_color = window.user_preferences.primary_bg_color || '#e8eef2';
            colors.secondary_bg_color = window.user_preferences.secondary_bg_color || '#4583BF';
            colors.secondary_bg_color_lighter = lightenDarkenColor(colors.secondary_bg_color, 10);
            colors.secondary_bg_color_darker = lightenDarkenColor(colors.secondary_bg_color, -10);

            // if (primary_bg_color) {
            //     // default = #e8eef2
            //     document.documentElement.style.setProperty('--primary-bg-color', primary_bg_color);
            // }

            // if (secondary_bg_color) {
            //     // default = #46b9c0
            //     document.documentElement.style.setProperty('--secondary-bg-color', secondary_bg_color);
            //     document.documentElement.style.setProperty('--secondary-bg-color-lighter', secondary_bg_color_lighter);
            //     document.documentElement.style.setProperty('--secondary-bg-color-darker', secondary_bg_color_darker);
            // }

            buildStyles(colors);
        }

        $(document).on('keyup change update input', '#userPreferencesForm input.colorpicker', function() {
            let colors = {};
            colors.primary_bg_color = window.user_preferences.primary_bg_color || '#e8eef2';
            colors.secondary_bg_color = window.user_preferences.secondary_bg_color || '#4583BF';
            colors.secondary_bg_color_lighter = lightenDarkenColor(colors.secondary_bg_color, 10);
            colors.secondary_bg_color_darker = lightenDarkenColor(colors.secondary_bg_color, -10);

            $('#userPreferencesForm input.colorpicker').each(function (index, element) {
                let color = $(element).val();
                let name = $(element).attr('name');
                colors[name] = color;

                if ($(element).hasClass('multiclass')) {
                    colors[name + '_lighter'] = lightenDarkenColor(color, 10);
                    colors[name + '_darker'] = lightenDarkenColor(color, -10);
                }
            });

            buildStyles(colors);
        });

        function buildStyles(colors) {
            let styles = `
                body {
                     background-color: ${colors.primary_bg_color};
                }

                .bg-secondary,
                .card-header,
                .card-footer,
                .table-status-report thead tr th {
                    background-color: ${colors.secondary_bg_color} !important;
                }

                .valid-feedback,
                .form-check-input.is-valid ~ .form-check-label,
                .custom-control-input.is-valid ~ .custom-control-label,
                .was-validated .form-check-input:valid ~ .form-check-label,
                .was-validated .custom-control-input:valid ~ .custom-control-label,
                .form-check-input:checked~.form-check-label .form-check-custom,
                .form-check-label:hover .form-check-custom,
                .dataTables_paginate .paginate_button,
                .form-control-wrap.success:after {
                    color: ${colors.secondary_bg_color};
                }

                .form-control:valid,
                .form-control:valid:focus,
                .custom-select.is-valid
                .was-validated .custom-select:valid,
                .custom-select.is-valid:focus,
                .was-validated .custom-select:valid:focus,
                .custom-control-input.is-valid ~ .custom-control-label:before,
                .was-validated .custom-control-input:valid ~ .custom-control-label:before,
                .custom-control-input.is-valid:focus:not(:checked) ~ .custom-control-label:before,
                .custom-file-input.is-valid ~ .custom-file-label,
                .was-validated .custom-control-input:valid:focus:not(:checked) ~ .custom-control-label:before,
                .was-validated .custom-file-input:valid ~ .custom-file-label,
                .custom-file-input.is-valid:focus ~ .custom-file-label,
                .was-validated .custom-file-input:valid:focus ~ .custom-file-label,
                .form-check-input:checked~.form-check-label,
                .form-control-wrap.success:after,
                .form-control-wrap.success .form-control {
                    border-color: ${colors.secondary_bg_color};
                }

                .btn-secondary,
                .custom-control-input.is-valid:checked ~ .custom-control-label:before,
                .was-validated .custom-control-input:valid:checked ~ .custom-control-label:before {
                    border-color: ${colors.secondary_bg_color};
                    background-color: ${colors.secondary_bg_color};
                }

                .text-secondary {
                    color: ${colors.secondary_bg_color};
                }

                .btn-outline-secondary {
                    color: ${colors.secondary_bg_color};
                    border-color: ${colors.secondary_bg_color};
                }

                .btn-outline-secondary:active,
                .btn-outline-secondary:hover,
                .nav-tabs .nav-link.active .nav-link-text,
                .nav-tabs .nav-link:hover .nav-link-text,
                .nav-tabs .nav-link.active:after,
                .nav-tabs .nav-link:hover:after {
                    background-color: ${colors.secondary_bg_color} !important;
                }

                .note-card .card-header .col:nth-child(even) {
                    background-color: ${colors.secondary_bg_color_lighter};
                    border-left: 1px solid ${colors.secondary_bg_color_darker};
                    border-right: 1px solid ${colors.secondary_bg_color_darker};
                }

                .alternate-card:nth-child(even) .card-header,
                .alternate-card:nth-child(even) .card-footer {
                    background: ${colors.secondary_bg_color_lighter};
                }

                .btn-secondary:hover {
                    background-color: #50C3CA;
                    border-color: ${colors.secondary_bg_color_darker};
                }

                .alternate-card .card-header,
                .alternate-card .card-footer{
                    border-right: 1px solid ${colors.secondary_bg_color_darker};
                }

                .btn-outline-secondary:hover {
                    border-color: ${colors.secondary_bg_color_darker};
                }
            `;

            if (!document.getElementById('#custom_css')) {
                $('head').append('<style id="#custom_css" type="text/css">'+styles+'</style>');
            } else {
                document.getElementById('#custom_css').innerHTML = styles
            }
        }

        $('.btn-reset-color').on('click', function () {
            let color = $(this).data('reset-color');
            $(this).closest('.colorpicker-wrapper').find('input').val(color).trigger('change');
        })

        $(window).on("keydown", function(e){
            window.shift = e.shiftKey
        });

        window.popover_templates = {
            confirm: `
                <div class="popover popover-success" role="tooltip">
                    <i class="fas fa-question-circle popover-tooltip"></i>
                    <div class="arrow"></div><h3 class="popover-header"></h3>
                    <div class="popover-body"></div>
                    <div class="p-2">
                        <a type="button" class="btn btn-danger mr-1 popover-trigger popover-cancel">Cancel</a>
                        <a class="btn btn-secondary popover-trigger popover-confirm">Confirm</a>
                    </div>
                </div>
            `,
            archive_confirm: `
                <div class="popover popover-success" role="tooltip">
                    <i class="fas fa-question-circle popover-tooltip"></i>
                    <div class="arrow"></div><h3 class="popover-header"></h3>
                    <div class="popover-body"></div>
                    <div class="p-2">
                        <a type="button" class="btn btn-default mr-1 popover-trigger popover-cancel">Cancel</a>
                        <a class="btn btn-warning popover-trigger popover-confirm">Archive</a>
                    </div>
                </div>
            `,
            unarchive_confirm: `
                <div class="popover popover-success" role="tooltip">
                    <i class="fas fa-question-circle popover-tooltip"></i>
                    <div class="arrow"></div><h3 class="popover-header"></h3>
                    <div class="popover-body"></div>
                    <div class="p-2">
                        <a type="button" class="btn btn-default mr-1 popover-trigger popover-cancel">Cancel</a>
                        <a class="btn btn-secondary popover-trigger popover-confirm">Unarchive</a>
                    </div>
                </div>
            `,
            "success" : '<div class="popover popover-success" role="tooltip"><i class="fas fa-check-circle popover-tooltip"></i><div class="arrow"></div><h3 class="popover-header"></h3><div class="popover-body"></div></div>',
            "failure" : '<div class="popover popover-failure" role="tooltip"><i class="fas fa-exclamation-circle popover-tooltip"></i><div class="arrow"></div><h3 class="popover-header"></h3><div class="popover-body"></div></div>'
        };

        $(document).on("click", ".popover-trigger", function(){
            if($(this).hasClass("popover-cancel")){
                $(window).trigger("confirm.bs.popover", [{...$(this).closest(".popover").data("bs.popover")}, false]);
            }
            if($(this).hasClass("popover-confirm")){
                $(window).trigger("confirm.bs.popover", [{...$(this).closest(".popover").data("bs.popover")}, true]);
            }
        });

        $(document).on("click", ".confirm-deletion", function () {
            let defaultOptions = {
                "placement": "left",
                "template": popover_templates.confirm,
                "title": "Delete this record?",
                "content": "This can\'t be undone",
                "delay": { "show": 0, "hide": 250 }
            };
            let options = $.extend({}, defaultOptions, $(this).data('options'));
            $(this).popover(options).popover("show");
        });

        $(document).on("click", ".disabled", (e)=>{
            e.preventDefault();
        });

        var skip = [
            "login",
            "register",
            "password/reset",
            "password/email",
            "search",
            "two-factor-challenge",
            "two-factor/resend",
        ];
        $(document).on("submit", "form", function(e){
            var action = $(this).attr("action");
            for(var i = 0, len = skip.length;i<len;i++){
                if(action.includes(skip[i])) return;
            }
            e.preventDefault();
            var method = $(this).attr("method");

            submit($(this), action, method);
        });

        $(document).on("click", ".form-btn",  function(e){
            var form = $(this).closest(".card");
            switch($(this).data("type")){
                case "discard":
                    e.preventDefault();
                    $.each($(this).data("data"), function(k, v){
                        if(k.includes("-checkbox")){
                            k = k.replace("-checkbox", "");
                            form.find("[name='"+k+"']").prop("checked", v).trigger("change");
                        }else{
                            let input = form.find("[name='"+k+"']");
                            if(!input.length) return;
                            input.val(v).trigger("change", [true]);
                            input[0].dispatchEvent(new Event('input', { 'bubbles': true }));
                        }
                    });
                    break;
                default:
                    break;
            }
        });

        $.each($('.select2'), function(i, e){
            init_select2($(e));
        });

        set_form_reset();

        $('.navbar-tps-main').on('click', '.nav-link-toggle', function(e){
            e.preventDefault();
            let type = $(this).data('type');
            let panel = $('.navbar-tps-main .nav-item-sub[data-type="'+type+'"]');

            if (panel.hasClass('always-open')) {
                return;
            }

            if (panel.hasClass('active')) {
                nav_close();
            } else {
                $('.navbar-tps-main .nav-link-toggle:not(.always-open)').removeClass('active');
                $(this).addClass('active');
                $('.navbar-tps-main').addClass('active');
                $('.navbar-tps-main .nav-item-sub:not(.always-open)').removeClass('active');
                panel.addClass('active');
            }
        });

        const popover_alert = $(".popover-alert-form");
        let msg_timeout;
        window.message = (msg, status, other_title = 'Failure', closeTimeout = 2500) => {
            if (typeof msg == 'undefined') msg = "Success.";

            let template = popover_templates.success;
            let title = "Success";
            switch(status){
                case 1:
                    template = popover_templates.failure;
                    title = other_title;
                    break;
                case 0:
                default:
                    break;
            }

            popover_alert.popover("dispose");

            popover_alert.popover({
                "placement":"left",
                "template":template,
                "title":title,
                "content":msg,
                "delay":{"show":0, "hide":250},
                "html":true
            }).popover("show");

            clearTimeout(msg_timeout);
            msg_timeout = setTimeout(function(){
                popover_alert.popover("dispose");
            }, closeTimeout);

        };

        /*Live Edits*/
        let tries = 0;
        let live_timeout;
        let live_queue = false;
        let live_submit = ($this) => {
            let form = $this.closest(".live-form");
            let parent = $this.closest(".form-control-wrap");

            if (form.data("lock")) return;

            let model = _.get(app, form.data("model"), false);

            if (model !== false) {
                if (Array.isArray(model)) {
                    model = model.find((ele) => {
                        let model_id = form.attr("data-model_id");
                        return ele.id==model_id;
                    });
                    if (typeof model == 'undefined') model = false;
                }

                if (model !== false) app.$set(model, "form_loading", true);
            }

            let payload = eleToJSON(form, form.find('.live-form :input'));
            form.data('queue', false);
            let last_payload = form.data('payload');

            if (JSON.stringify(last_payload) == JSON.stringify(payload)) {
                if (model !== false) model.form_loading = false;
                return;
            }

            form.data('lock', true);
            form.data('payload', payload);

            $(window).trigger(form.attr('action') + '.form-submitting', [form]);

            $.ajax({
                method: 'POST',
                url: form.attr('action'),
                data: form.data('payload'),
                success: (response) => {
                    if (typeof response['error'] !== 'undefined') {
                        message(response['error'], 1);
                        form.data('lock', false);
                        if (typeof model !== 'undefined') model.form_loading = false;
                        return;
                    }

                    if (response.hasOwnProperty('no_message') && response['no_message']) {
                        //
                    } else {
                        let msg = 'Record Updated.';
                        if (typeof response['message'] !== 'undefined') msg = response['message'];
                        if (typeof response['prompt'] !== 'undefined') {
                            Swal.fire({
                                title: 'Updated',
                                text: msg,
                                icon: 'success',
                                heightAuto: false,
                            });
                        } else {
                            message(msg);
                        }
                    }

                    parent.addClass("success");

                    if (typeof response["updated"] != 'undefined') {
                        form_populate(form, response["updated"], false, "[type='hidden'],[disabled],[data-fillable='true']");
                    }

                    $(window).trigger("form-success", [response, form.attr("action")]);
                    $(window).trigger(form.attr("action")+".success", [response, form]);

                    setTimeout(() => {
                        form.data("lock", false);
                        if (form.data("queue")) {
                            live_submit($this);
                        } else {
                            if (model !== false) model.form_loading = false;
                        }
                    }, 10);

                    window.notification_worker();
                },
                error: (response)=> {
                    form.data("lock", false);
                    if (response.status == 422) {
                        if (response.responseJSON.errors) {
                            message("<ul class='pl-4'><li>" + validateErrors(response.responseJSON.errors).join("</li><li>") + "</li></ul>", 1);
                        } else {
                            let msg = response.responseJSON.error_message || 'The given data was invalid.';
                            message(msg, 1)
                        }
                    }

                    if (model !== false) model.form_loading = false;

                    $(window).trigger(form.attr("action") + ".error", [response, form]);

                    if (tries > 5) {
                        tries = 0;
                        message("Couldn't save record!", 1);
                        $(window).trigger("form-error", [response, form.attr("action")]);
                        $(window).trigger(form.attr("action")+".error", [response, form]);

                        return;
                    }

                    tries++;
                    live_submit($this);
                }
            });
        };

        let live_update = ($this)=>{
            let form = $this.closest('.live-form');
            form.data('queue', true);
            clearTimeout(form.data('timeout'));
            form.data('timeout', setTimeout(()=>{
                let parent = $this.closest('.form-control-wrap');
                parent.removeClass('success error');

                if ($this[0].validity.valid) {
                    live_submit($this);
                } else {
                    parent.addClass('error');
                }

                if ($this.attr('type') == 'checkbox') {
                    $this.data('oldVal', $this.is(':checked'));
                } else {
                    $this.data('oldVal', $this.val());
                }
            }, 750));
        };

        $(document).on('keyup change update input', '.live-form :input:not(.live-skip)', function(e, skip) {
            let $this = $(this);

            if (skip) return;

            // console.log($this.val());
            // console.log($this.data('oldVal'));

            if ($this.val() == $this.data('oldVal')) return;

            live_update($this);
        });

        if (required_pages.includes(path)) {
            function confirmLeave (e) {
                e.returnValue = 'Are you sure you want to leave page?';
                return 'Are you sure you want to leave page?';
            }

            // window.onbeforeunload = showSiteLoader;

            /**Turning off notification popups for now. */
            $("a").on('click', function (e) {
                return;
                window.onbeforeunload = null;

                let href = $(this).attr("href");

                if(href=="#" || !ll_defined(href)) return;

                if(app.fields == ""){
                    window.location.href = href;
                    return;
                };

                e.preventDefault();
                e.stopPropagation();

                Swal.fire({
                    title: 'Are you sure?',
                    text: "The following fields need a value: " + app.fields,
                    type: 'warning',
                    showCancelButton: true,
                    confirmButtonColor: '#14A3F9',
                    cancelButtonColor: '#FF1D25',
                    confirmButtonText: 'Yes, I want to leave.'
                }).then((result) => {
                    if (result.value) {
                        window.location.href = href;
                    }else{
                        window.onbeforeunload = confirmLeave;
                    }
                });
            });
        }
    });

    $(window).on('beforeunload', function () {
        $('.loading-overlay').show();
    });

    $(window).on('pageshow', function () {
        setTimeout(function () {
            if ($('.loading-overlay').is(':visible')) {
                $('.loading-overlay').hide();
            }
        }, 500);
    });

    function checkMenu() {
        if ($(window).width() > 1079) {
            $('#searchPlacement').removeClass('active');
            $('.navbar-tps-main').removeClass('active');
            if ($('.btn-hamburger').hasClass('is-active')) {
                $('.btn-hamburger').removeClass('is-active');
            }
        }
    }

    checkMenu();

    window.eleToJSON = function(f, n){
        n = typeof n == 'undefined'?"":n;
        var fd = $(f).find(":input").not(n).serializeArray();
        var d = {};
        $(fd).each(function() {
            let val = this.value;
            switch($("input[name='"+this.name+"']").data("type")){
                case "currency":
                    val = isNaN(parseFloat(this.value.replace(/,/g,''))) ? 0 : parseFloat(this.value.replace(/,/g,''));
                    break;
                default:
                    break;
            }
            if (d[this.name] !== undefined){
                if (!Array.isArray(d[this.name])) {
                    d[this.name] = [d[this.name]];
                }
                d[this.name].push(val);
            }else{
                d[this.name] = val;
            }
        });
        $(f).find("input:checkbox").each(function(){
            d[this.name] = this.checked?1:0;
        });
        return d;
    };

    window.form_populate = function(display, data, parent, rules){
        if(typeof rules == 'undefined') rules = "";
        $.each(data, function(k, v) {
            if(v==null || typeof v == 'undefined') v = "";
            if(typeof parent=='undefined' || !parent){
                var name = "[name='"+k;
            }else{
                var name = parent+"["+k+"]";
            }
            if(v.constructor.name == "Object" || v.constructor.name == "Array"){
                form_populate(display, v, name, rules);
                return;
            }
            name+="']";
            let rule_arr = rules.split(",");
            rule_arr.forEach((r,i)=>{rule_arr[i] = name+r});
            var input = display.find(rule_arr.join(","));

            if (display.hasClass("live-form")) {
                input = $(input.filter(function() {
                    return (display[0]==$(this).closest(".live-form")[0]);
                })[0]);
            }

            if (input.length > 0) {
                var type = input.attr("type");
                if (input.hasClass("select2-hidden-accessible")) type = "select";
                switch(type) {
                    case "checkbox":
                        if (v == 1 || v === true) {
                            input.prop("checked", true).trigger("change", [true]);
                        }else{
                            input.prop("checked", false).trigger("change", [true]);
                        }
                        break;
                    case "select":
                        input.val(v).trigger('change', [true]);
                        // input.html("<option value='"+v+"'></option>").val(v).trigger("change", [true]);
                        break;
                    default:
                        if(input.val()!==v){
                            input.val(v).trigger("change", [true]);
                            input[0].dispatchEvent(new Event('input', { 'bubbles': true }));
                        }
                        break;
                }
            }
        });

        $.each($('.select2'), function (i, e) {
            init_select2($(e));
        });
    };

    window.init_select2 = function($this){
        if(!$this.is("select")) return;
        var data = parseNestedDataSet($this.data());
        $this.select2(data);
    };

    window.init_datepicker = function ($this) {
        $this.datepicker({
            uiLibrary: 'bootstrap4',
            open: function open(e) {
                $(this).closest(".form-datepicker").addClass("active");
                $(this).closest(".form-datepicker").removeClass("success");
            },
            close: function close(e) {
                $(this).closest(".form-datepicker").removeClass("active");
                if ($(this).val() !== "") $(this).closest(".form-datepicker").addClass("success");else $(this).closest(".form-datepicker").removeClass("success");
                $(this).trigger("change");
            }
        });
    };

    function set_form_reset(){
        $.each($(".form-btn[data-type='discard']"), function(){
            var data = {};
            var form = $(this).closest(".card");
            $.each(form.find(":input"), function(){
                if($(this).attr("type")=="checkbox"){
                    data[$(this).attr("name")+"-checkbox"] = $(this).is(":checked");
                }else{
                    data[$(this).attr("name")] = $(this).val();
                }
            });
            $(this).data("data", data);
        });
    }

    function submit(form, action, method){

        if(form.data("submitting") == true || form.hasClass("live-form")) return;

        var data = eleToJSON(form, form.find(".live-form :input"));

        data['data'] = form.data("post_data");

        form.data("submitting", true);

        message("Saving...");

        if (form.find('.card-loader').length) {
            form.find('.card-loader').addClass('loading');
        }

        $.ajax({
            url: action,
            method: method,
            data: data,
            dataType: 'json',
            success: function(response){

                var msg = "Completed.";

                if (typeof response['message'] !== 'undefined') {
                    msg = response['message'];
                    if (action == '/api/contact/maybe_create' && window.location.pathname && !window.location.pathname.startsWith('/placement/edit/')) {
                        location.reload();                        
                    }
                }

                if (typeof response['error'] !== 'undefined') {
                    message(msg, 1);
                    $(window).trigger("form-error", [response, action]);
                    $(window).trigger(action+".error", [response]);
                } else {
                    if (typeof response['original'] !== 'undefined') {
                        form_populate(form, response['original']);
                    }

                    if (response) {
                        response['submission'] = {
                            "form":form,
                            "data":data
                        };
                    }

                    message(msg);
                    $(window).trigger("form-success", [response, action]);
                    $(window).trigger(action+".success", [response, form]);
                }
            },
            error: function(response){
                let msg = "Something went wrong please try again.";
                let closeTimeout = 3000;

                if (typeof response['responseJSON'] !== 'undefined') {
                    if (typeof response['responseJSON']['message'] !== 'undefined'){
                        msg = response['responseJSON']['message'];
                    }

                    if (response.status === 422) {
                        if (response.responseJSON.errors) {
                            msg = "<ul class='pl-4'><li>" + validateErrors(response.responseJSON.errors).join("</li><li>") + "</li></ul>";
                        }
                        closeTimeout = 5000;
                    }
                }

                message(msg, 1, 'Failure', closeTimeout);
                $(window).trigger("form-error", [response, action]);
                $(window).trigger(action+".error", [response]);
            },
            complete: function(response){
                form.data("submitting", false);

                if (form.find('.card-loader').length) {
                    form.find('.card-loader').removeClass('loading');
                }
            }
        });

    }

    var timeout;

    window.nav_close = () => {
        $('.navbar-tps-main .nav-link:not(.always-open)').removeClass('active');
        $('.navbar-tps-main').removeClass('active');
        $('.navbar-tps-main .nav-item-sub:not(.always-open)').removeClass('active');
        $('.navbar-tps-main .nav-link').filter(function() {
            return location.href.includes($(this).data('type'));
        }).addClass('active');
    }

    /*Utility For Testing*/
    window.obj_clean = function(obj){
        for(var k in obj){
            if(typeof obj[k] == "object"){
                obj_clean(obj[k]);
            }else{
                obj[k] = null;
            }
        }
    };

    window.form_autofill = function(){
        /*AutoFill Form Content*/
        var now = new Date();

        var day = ("0" + now.getDate()).slice(-2);
        var month = ("0" + (now.getMonth() + 1)).slice(-2);

        var today = (month)+"/"+(day)+"/"+now.getFullYear();

        $("form input[type='text']:not([data-type='datepicker']), form textarea, form input[type='email']").val("test@test.com");
        $("form input[data-type='datepicker']").val(today);
        $("form input[type='number']").val(1);
        $(":input").trigger("blur");
    };

    function parseNestedDataSet(data_set) {
        var data = {};
        for (var i = 0; i < Object.keys(data_set).length; i++) {
            var key = Object.keys(data_set)[i];
            var value = data_set[key];
            var splat = key.split('-');

            data = parseNestedDataSetKey(splat, value, data);
        }

        return data;
    }

    function parseNestedDataSetKey(keys, value, data) {
        data = data || {};
        var key = keys[0].toLowerCase();

        // Not tested, but should convert to camel case
        //var key = keys[0].replace(/-([a-z])/g, function (g) {
        //      return g[1].toUpperCase();
        //});

        if (!data[key]) {
            data[key] = {};
        }

        if (keys.length > 1) {
            keys.splice(0, 1);
            data[key] = parseNestedDataSetKey(keys, value, data[key]);
        } else {
            data[key] = value;
        }

        return data;
    }

    var rad = function(x) {
        return x * Math.PI / 180;
    };

    window.getDistance = function(p1, p2) {
        var R = 6378137; // Earth’s mean radius in meter
        var dLat = rad(p2.lat() - p1.lat());
        var dLong = rad(p2.lng() - p1.lng());
        var a = Math.sin(dLat / 2) * Math.sin(dLat / 2) +
          Math.cos(rad(p1.lat())) * Math.cos(rad(p2.lat())) *
          Math.sin(dLong / 2) * Math.sin(dLong / 2);
        var c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
        var d = R * c;
        return getMiles(d); // returns the distance in meter
    };

    var getMiles = function(i){
        return i*0.000621371192;
    }
    var getMeters = function(i){
        return i*1609.344;
    }

    var validateErrors = (errors) => {
        errors = Object.values(errors)
        errors = errors.flat()

        return errors
    }


})(jQuery);



// WEBPACK FOOTER //
// ./resources/assets/js/app.js